var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpdateNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.878 0.610352C10.878 0.610352 8.05114 11.1196 0 11.1196C8.05114 11.1196 10.878 21.6283 10.878 21.6283C10.878 21.6283 13.7048 11.1196 21.7559 11.1196C13.7048 11.1196 10.878 0.610352 10.878 0.610352Z",
    fill: "#4D6996"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9116 7.90155C18.9116 7.90155 19.9742 3.95078 23.0007 3.95078C19.9742 3.95078 18.9116 0 18.9116 0C18.9116 0 17.8488 3.95078 14.8223 3.95078C17.8488 3.95078 18.9116 7.90155 18.9116 7.90155Z",
    fill: "#4D6996"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72491 15.9692C4.72491 15.9692 3.96431 18.7963 1.79883 18.7963C3.96431 18.7963 4.72491 21.6225 4.72491 21.6225C4.72491 21.6225 5.48531 18.7963 7.651 18.7963C5.48531 18.7963 4.72491 15.9692 4.72491 15.9692Z",
    fill: "#4D6996"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpdateNote);
export default __webpack_public_path__ + "static/media/icon-update-note.4888a5ee1acbe38255bfe25136b0efa2.svg";
export { ForwardRef as ReactComponent };